import { createContext } from "react";

// Create Security Context
export const SecurityContext = createContext(null);

export default SecurityContext;
